<template>
  <div :class="{ 'rewards': true, 'is-loading': !loaded }">
    <d-alert
      v-if="referenceId === 0"
      theme="light"
      show
      class="text-center">
      You will be able to see and add rewards after saving this {{ itemName }}.
    </d-alert>

    <d-alert
      v-if="loadError"
      theme="warning"
      show
      class="text-center">
      An error occurred during loading rewards.
    </d-alert>

    <d-row
      v-if="loaded && !loadError && referenceId !== 0"
      class="pr-3 mb-3">
      <d-button
        theme="success"
        size="sm"
        @click.prevent="addReward"
        outline
        class="ml-auto">
        Add reward
      </d-button>
    </d-row>

    <d-row
      v-if="loaded && !loadError && referenceId !== 0 && rewards.length > 0"
      class="pl-3 pr-3">
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Reference</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <rewards-list-item
            v-for="(rewardData, index) of rewards"
            :key="'rewards-list-item-' + index"
            :rewardData="rewardData" />
        </tbody>
      </table>
    </d-row>

    <d-alert
      v-if="loaded && !loadError && referenceId !== 0 && rewards.length === 0"
      theme="light"
      show
      class="text-center">
      There are no rewards for this {{ itemName }}.
    </d-alert>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import RewardsListItem from './RewardsListItem.vue';

export default {
  name: 'rewards',
  components: {
    'rewards-list-item': RewardsListItem
  },
  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    itemName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      rewards: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadRewards();
    }

    this.$bus.$on('rewards-list-reload', this.reload);
  },
  methods: {
    loadRewards () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/rewards/items',
        params: {
          pagination: 0,
          where: {
            reference_id: this.referenceId,
            reference_type: this.referenceType
          }
        },
        loadedKey: 'loaded',
        outputKey: 'rewards',
        errorKey: 'loadError'
      });
    },
    addReward () {
      this.$bus.$emit('show-reward-popup', this.referenceType, this.referenceId);
    },
    reload () {
      this.loaded = false;
      this.loadRewards();
    }
  },
  beforeDestroy () {
    this.$bus.$off('rewards-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.rewards {
  margin: -32px 0 20px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
